import { Table } from 'ui/table';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { ORGANIZATIONS_STATS_TABLE_COLUMNS } from '../constants';
import type { OrganizationStatsTableProps } from '../types';

export const OrganizationStatsTable = ({ organizations }: OrganizationStatsTableProps) => {
  return (
    <Table>
      <TableHeader columns={ORGANIZATIONS_STATS_TABLE_COLUMNS} />
      <TableRows columns={ORGANIZATIONS_STATS_TABLE_COLUMNS} rows={organizations} />
    </Table>
  );
};
